module.exports = __webpack_public_path__ + "img/carrito-compra.2e1c15bd.svg";